import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import accounting from 'accounting'
import {
  Button,
  Form,
  FormGroup,
  FormText,
  Label,
  Image,
  InputGroup,
  InputGroupAddon,
  Input,
  Row,
  Col,
} from 'components/qstrap'
import InputSelect from 'components/atoms/InputSelect'
import config from 'config'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import triggerEvent from 'utils/dataLayer'

const { assets_url: assetsUrl } = config

class PartialForm extends Component {
  constructor(props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.loanAmount = this.loanAmount.bind(this)

    this.state = {
      invalidAmount: false,
    }

    accounting.settings = {
      currency: {
        symbol: '',
        format: '%s%v',
        decimal: ',',
        thousand: '.',
        precision: 0,
      },
      number: {
        precision: 0,
        thousand: '.',
        decimal: ',',
        symbol: '',
      },
    }
  }

  onSubmit(e) {
    e.preventDefault()
    const {
      amount, duration, schoolId, gaPrefix,
    } = this.props

    if (schoolId) {
      const data = {
        source: 'koinworks',
        source_detail: {
          amount,
          duration,
        },
      }

      const options = {
        headers: {
          'X-CSRF-Token': csrfToken(),
        },
      }

      API.put(API.endPoints({ id: schoolId }).leads.update, data, options).then(() => {
        triggerEvent(`ga/${gaPrefix}/bottombanner-right`, data)
        window.open('https://forms.gle/L6Md7JMe5xqCexSGA', '_blank')
      })
    } else {
      window.open('https://forms.gle/L6Md7JMe5xqCexSGA', '_blank')
    }
  }

  doFormatMoney(value) {
    return accounting.formatMoney(value)
  }

  doFormatPercent(value) {
    if (value < 10) return 10
    if (value > 90) return 90
    return value
  }

  tenorOptions() {
    const data = []
    const options = [6, 9, 12, 15, 18, 21, 24]
    options.map(val => data.push({ text: `${val} Bulan`, id: val }))

    return data
  }

  loanAmount() {
    const {
      amount, downPayment, minAmount,
    } = this.props

    if ((amount >= minAmount) && downPayment >= 10 && downPayment <= 90) {
      const result =  amount - ((downPayment / 100) * amount)
      return this.doFormatMoney(result)
    }

    return '-'
  }

  isValid() {
    const {
      amount, duration, minAmount,
    } = this.props

    if (
      accounting.unformat(amount) < minAmount ||
      !duration
    ) {
      return false
    }

    return true
  }

  render() {
    const {
      onChange,
      duration,
      totalMax,
      totalMin,
      minAmount,
      gaPrefix,
    } = this.props

    const {
      invalidAmount,
    } = this.state

    return (
      <div className="area bg-white m-b-0 p-y-lg m-y-lg text-left">
        <Form onSubmit={this.onSubmit}>
          <FormGroup className={classNames({ 'is-invalid': invalidAmount })}>
            <Label>Biaya Kuliah (min. Rp 10.000.000)</Label>
            <InputGroup className="m-b-md">
              <InputGroupAddon>Rp</InputGroupAddon>
              <Input
                name="amount"
                onChange={(e) => {
                  this.setState({ invalidAmount: false })
                  e.target.value = this.doFormatMoney(e.target.value)
                  onChange(e)
                }}
                onBlur={(e) => {
                  if (accounting.unformat(e.target.value) < minAmount) {
                    this.setState({ invalidAmount: true })
                  }
                }}
                onFocus={() => {
                  triggerEvent(`ga/${gaPrefix}/bottombanner-right-top`)
                }}
                className="placeholder-gray"
                required
              />
            </InputGroup>
            { invalidAmount && <FormText className="text-danger">Minimal pinjaman Rp. 10.000.000</FormText> }
          </FormGroup>
          <FormGroup>
            <Row>
              <Col md="6" className="sm-down-m-b-md">
                <Label>Tenor</Label>
                <InputSelect
                  name="duration"
                  selectOptions={this.tenorOptions()}
                  handleChange={onChange}
                  value={duration}
                  options={{
                    theme: 'qstrap',
                  }}
                  onChange={() => {
                    triggerEvent(`ga/${gaPrefix}/bottombanner-right-mid`)
                  }}
                  required
                />
              </Col>
              <Col md="6">
                <Label>Uang Muka (10% - 90%)</Label>
                <InputGroup>
                  <Input
                    type="number"
                    name="downPayment"
                    onChange={onChange}
                    placeholder="10"
                    onBlur={(e) => {
                      e.target.value = this.doFormatPercent(e.target.value)
                      onChange(e)
                    }}
                    onFocus={() => {
                      triggerEvent(`ga/${gaPrefix}/bottombanner-right-bottom`)
                    }}
                    className="placeholder-gray"
                    required
                  />
                  <InputGroupAddon>%</InputGroupAddon>
                </InputGroup>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Label>Jumlah Pinjaman</Label>
            <InputGroup>
              <InputGroupAddon>Rp</InputGroupAddon>
              <Input
                name="amount"
                value={this.loanAmount()}
                readOnly
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>Bunga</Label>
            <Input
              name="amount"
              value="0.75% - 1.25%"
              readOnly
            />
          </FormGroup>
          <FormGroup>
            <Label>Perkiraan Cicilan Perbulan</Label>
            <InputGroup>
              <InputGroupAddon>Rp</InputGroupAddon>
              <Input
                name="amount"
                value={`${this.doFormatMoney(totalMin)} - ${this.doFormatMoney(totalMax)}`}
                readOnly
              />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col md="12">
                <div className="text-confirmation m-y-md">
                  Dengan ini Anda menyetujui syarat dan ketentuan dari Quipper Campus
                </div>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup className="m-b-0">
            <Row className="m-b-md">
              <Col md="8" className="col-md-offset-2">
                <Button
                  type="submit"
                  color="campus"
                  className="font-bold"
                  disabled={!this.isValid()}
                  onClick={() => triggerEvent(`${gaPrefix}/campusprofile/bottombanner-right`)}
                  block
                >
                  Daftar Sekarang
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="powered-by-koinworks">
                  <Image
                    src="/assets/img/logo/koinworks.png"
                    srcSet={`${assetsUrl}/assets/img/logo/koinworks@2x.png 2x, ${assetsUrl}/assets/img/logo/koinworks@3x.png 3x`}
                    alt="koinworks"
                  />
                </div>
              </Col>
            </Row>
          </FormGroup>
        </Form>
      </div>
    )
  }
}

PartialForm.propTypes = {
  onChange: PropTypes.func,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  downPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  duration: PropTypes.number,
  totalMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalMin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  schoolId: PropTypes.string,
  minAmount: PropTypes.number,
  gaPrefix: PropTypes.string,
}

PartialForm.defaultProps = {
  gaPrefix: 'campusprofile',
}

export default PartialForm
